import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { LoginService } from './login.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-login',
  imports: [MatButton, TranslatePipe],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  constructor(protected loginService: LoginService) {
  }

  login() {
    this.loginService.login();
  }
}
